module.exports = __webpack_public_path__ + "img/Haefele_menu5.760b1987.png";